<div class="login-container">
  <div class="left-section">
    <h3 class="description">
      {{ 'LOGIN.WELCOME' | transloco }}
    </h3>
  </div>

  <div class="right-section">
    <div class="welcome-text text-center my-5">
      <h3>{{ 'RESET_PASSWORD.RESET_YOUR_PASSWORD' | transloco }}</h3>
      <mat-slide-toggle class="my-3" [(ngModel)]="showDetails">{{ 'ACTIVATE_USER.PASSWORD_REQUIREMENTS' | transloco
        }}</mat-slide-toggle>
      <form [formGroup]="resetPasswordForm">
        @if (!code) {
        <mat-form-field appearance="outline">
          <mat-label>{{ 'ACTIVATE_USER.ENTER_CODE' | transloco }}...</mat-label>
          <input matInput placeholder="{{code}}" formControlName="code" required>
          <mat-icon matSuffix>account_box</mat-icon>
          <!-- <mat-error
            *ngIf="!activateUserForm.controls.customerName.valid && activateUserForm.controls.customerName.touched">
            Något ser inte rätt ut...
          </mat-error> -->
        </mat-form-field>
        }

        <div fxFlex>

          <mat-form-field appearance="outline" class="full-width">
            <!-- [disabled]="!this.resetPasswordForm.controls.oldPassword.status === 'INVALID'"> -->
            <mat-label>{{ 'ACTIVATE_USER.NEW_PASSWORD' | transloco }}</mat-label>
            <mat-pass-toggle-visibility matSuffix></mat-pass-toggle-visibility>
            <input matInput #password required placeholder="Nytt lösenord" type="password" autocomplete="off"
              formControlName="password" required>
            @if (resetPasswordForm.hasError('required', 'password')) {
            <mat-error>
              {{ 'SETTINGS.NEW_PASSWORD_REQUIRED' | transloco }}
            </mat-error>
            }
            <mat-hint align="end" aria-live="polite">
              {{password.value.length}} / 30 <!-- {{passwordComponent.max}} -->
            </mat-hint>
          </mat-form-field>
          <app-password-strength [passwordToCheck]="resetPasswordForm.value.password"
            [showRequirements]="showDetails"></app-password-strength>
        </div>


        @if (code) {
        <mat-form-field class="mt-3" appearance="outline">
          <mat-label>{{ 'ACTIVATE_USER.CONFIRM_PASSWORD' | transloco }}</mat-label>
          <mat-pass-toggle-visibility matSuffix></mat-pass-toggle-visibility>
          <input matInput placeholder="{{ 'ACTIVATE_USER.CONFIRM_PASSWORD' | transloco }}" type="password"
            autocomplete="off" formControlName="confirmedPassword" required>
          @if (!resetPasswordForm.controls.confirmedPassword.valid &&
          resetPasswordForm.controls.confirmedPassword.touched) {
          <mat-error>
            {{ 'ACTIVATE_USER.SOMETHING_IS_WRONG' | transloco }}...
          </mat-error>
          }
        </mat-form-field>
        }
        <button mat-raised-button class="mt-2 full-width" (click)="resetPassword()" color="primary" type="button"
          [disabled]="!resetPasswordForm.valid">
          {{ 'RESET_PASSWORD.RESET_AND_LOGIN' | transloco }}
        </button>
      </form>
    </div>
  </div>
</div>
<app-footer></app-footer>